import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../marjorie_lashdesign/marjorie_lashdesign.module.scss';
import perfil from '../marjorie_lashdesign/src/perfil.png';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';

const cardImages = [
    {
        id: 1,
        image: require("./src/cards/1.png"),
        link: "/marjorie_lashdesign/agendamento",
        linkInterno: true,
    },
    {
        id: 2,
        image: require("./src/cards/2.png"),
        link: "/marjorie_lashdesign/curso",
        linkInterno: true,
    },
    {
        id: 3,
        image: require("./src/cards/3.png"),
        link: "/marjorie_lashdesign/procedimentos",
        linkInterno: true,
    },
];

const marjorie_lashdesign: React.FC = () => {
    const whatsappLink = `https://wa.me/5564993010303`;

    return (
        <div className={styles.marjorie_lashdesign}>
            <div className={styles.container}>
                <img src={perfil} alt="Perfil" className={styles.perfil} />
                <div className={styles.cards}>
                    {cardImages.map((card, index) =>
                        card.linkInterno ? (
                            <Link to={card.link} key={index} className={styles.card}>
                                <img src={card.image} alt={`Card ${card.id}`} />
                            </Link>
                        ) : (
                            <a href={card.link} target="_blank" rel="noopener noreferrer" key={index} className={styles.card}>
                                <img src={card.image} alt={`Card ${card.id}`} />
                            </a>
                        )
                    )}
                </div>

                <div className={styles.footer}>
                    <a
                        href={whatsappLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.footerWhatsapp}
                        aria-label="WhatsApp"
                    >
                        <div className={styles.footerTop}>
                            <WhatsappIcon height="32" color="#111" />
                            <span className={styles.footerText}>Para mais informações<br />Entre em contato pelo WhatsApp</span>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default marjorie_lashdesign;
